import { AxiosError } from 'axios';

import { ZOR_DATA_CENTER_CLOSED_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ClosedApiResponse } from '@/types/data-center/closed.type';
import { ApiResponse } from '@/types/response.type';

interface GetZorClosedDataParams {
  page: number;
  limit: number;
}

const getZorClosedData = async ({
  page,
  limit,
}: GetZorClosedDataParams): Promise<ApiResponse<ClosedApiResponse>> => {
  try {
    const response = await apiManager.get(ZOR_DATA_CENTER_CLOSED_API_URL, {
      headers: { 'Content-Type': 'application/json' },
      params: { page, limit },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getZorClosedData;
